(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardAdminPatientOrderScheduleController', DashboardAdminPatientOrderScheduleController);

    DashboardAdminPatientOrderScheduleController.$inject = ['CoreService', 'hasPrinter', '$rootScope', 'date', '$uibModal', '$compile', '$q', '$scope', 'GUIUtils', 'PatientOrder', 'DTOptionsBuilder', 'DTColumnBuilder', 'DateUtils', 'DYMO'];

    function DashboardAdminPatientOrderScheduleController(CoreService, hasPrinter, $rootScope, date, $uibModal, $compile, $q, $scope, GUIUtils, PatientOrder, DTOptionsBuilder, DTColumnBuilder, DateUtils, DYMO) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.barCode = {};
        vm.oDate1 = new Date(date);
        vm.hasPrinter = hasPrinter;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;

        vm.barcodes = [];

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.clinic) {
                PatientOrder.dashboardSchedule({
                    clinicId: vm.clinic.id,
                    date: vm.oDate1,
                    shift: -1
                }, function (result) {
                    vm.orders = setUniqueIds(result);
                    defer.resolve(vm.orders);

                    vm.selected = {};
                    vm.selectAll = false;
                });
            } else {
                defer.resolve(vm.orders);
            }

            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + data.middleName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('D.O.B').withOption('width', '110px').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? showBarcode(data) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tests').withOption('width', '90px').renderWith(function (data, type, full, meta) {
                return showCompendiumHtml(data.id);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected').withOption('width', '80px').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.collected);
            })
        ];

        vm.printLabels = function () {
            if (vm.hasPrinter) {
                vm.barcodes = getSelectedBarcodes();

                if (vm.barcodes.length > 0) {
                    PatientOrder.getBarcodeLabels({barcodes: vm.barcodes}, function (result) {
                        DYMO.printPatientBarcodes(result);

                        vm.barcodes = [];
                    });
                }
            }
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        $scope.$on('dialysisApp:dashboardAdminCalendarUpdate', function (event, result) {
            vm.oDate1 = result;
            vm.selected = {};
            vm.selectAll = false;
            vm.search();
        });

        function showBarcode(row) {
            return '<a ui-sref="' + "clinic-schedule-pdetail-barcode({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
        }

        function showCompendiumHtml(row) {
            return '<a class="btn-sm btn-info" ng-click="vm.showCompendiums(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        };

        vm.showCompendiums = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/compendium/compendium-list-dialog.html',
                controller: 'CompendiumListDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    compendiums: ['Compendium', function (Compendium) {
                        if (vm.orders[index].barcode) {
                            return Compendium.by_patient_with_barcode({barcode: vm.orders[index].barcode}).$promise;
                        } else {
                            return Compendium.by_patient_without_barcode({
                                patient: vm.orders[index].patientId,
                                date: DateUtils.convertLocalDateToServer(vm.oDate1),
                                physician: vm.orders[index].pId
                            }).$promise;
                        }
                    }]
                }
            });
        };

        function getSelectedIds() {
            var orders = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    orders.push(id);
                }
            }

            return orders;
        }

        function setUniqueIds(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].id = i;
            }

            return data;
        }

        function getSelectedBarcodes() {
            var barcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    if (vm.orders[id].barcode != null) {
                        barcodes.push(vm.orders[id].barcode);
                    }
                }
            }

            return barcodes;
        }
    }
})();
